import { render } from "./ProfilePicture.vue?vue&type=template&id=5604e6c5&scoped=true&ts=true"
import script from "./ProfilePicture.vue?vue&type=script&lang=ts"
export * from "./ProfilePicture.vue?vue&type=script&lang=ts"

import "./ProfilePicture.vue?vue&type=style&index=0&id=5604e6c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5604e6c5"],['__file',"src/components/ProfilePicture.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5604e6c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5604e6c5', __exports__)) {
    api.reload('5604e6c5', __exports__)
  }
  
  module.hot.accept("./ProfilePicture.vue?vue&type=template&id=5604e6c5&scoped=true&ts=true", () => {
    api.rerender('5604e6c5', render)
  })

}


export default __exports__